module.exports = __webpack_public_path__ + "iphone-sms.5ce155f1b394.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/home/iphone-sms.png
// module id = ./src/styles/marketing/home/iphone-sms.png
// module chunks = 21